import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../network/apis/apiClient";
// import { getRailRoadDataService } from 'network/services/chart.service';

export const getSevenALoadingDetails = createAsyncThunk(
  "chart/railroad-data",
  async (params, thunkApi) => {
    try {
      // const res = await axios.get('https://jsonplaceholder.typicode.com/posts')
      const res = await apiClient.get("/data7aloading");
      // .then(response => {
      // })
      // .catch(error => {
      //   console.error('Error:', error);
      // });
      return res;
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description);
    }
  }
);
